// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
// components
import { IconButton, Tooltip } from '@lyearn/ui';
import { IconButtonAppearance } from '@lyearn/ui/dist/esm/Buttons/IconButton/types';

import { ToolbarButtonProps } from '../../types';
import { activeStyles } from './styles';

function MarkOption({
  variant = 'ghost',
  appearance = 'secondary',
  blockName,
  tooltipKey,
  Icon,
  editorOption,
  onClick,
  isHidden,
  className = 'me-4',
  isActive,
}: ToolbarButtonProps) {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Tooltip placement="bottom" title={tooltipKey ? t(tooltipKey)! : ''}>
      <IconButton
        Icon={Icon}
        appearance={appearance as IconButtonAppearance}
        className={cn(className, isActive ? cn('bg-bg-onclick', activeStyles) : '')}
        shape="square"
        size="s"
        variant={variant}
        onClick={() => onClick(blockName!, editorOption!)}
      />
    </Tooltip>
  );
}

export default React.memo(MarkOption);
